import { render, staticRenderFns } from "./DetalleInscritos.vue?vue&type=template&id=73d2a72c&"
import script from "./DetalleInscritos.vue?vue&type=script&lang=js&"
export * from "./DetalleInscritos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports